import { defineNuxtRouteMiddleware, navigateTo } from '#app';

import { useService } from '@nzyme/vue-ioc/useService.js';
import { AuthStore } from '@sigma/client/auth/AuthStore.js';
import { useLocale } from '@sigma/client/i18n/useLocale.js';
import { isRouteAuthorized } from '@sigma/client/routes/isRouteAuthorized.js';
import { LandingRoute } from '@sigma/patient-common/routes.js';
import { getLoginRoute } from '@sigma/patient-common/routeUtils.js';

export default defineNuxtRouteMiddleware(async to => {
    const locale = useLocale();

    if (to.path === '/') {
        return navigateTo(LandingRoute({ locale: locale.value }));
    }

    if (!to.meta.auth || import.meta.server) {
        return;
    }

    const authStore = useService(AuthStore);
    await authStore.checkAuth();
    if (!authStore.auth) {
        return navigateTo(getLoginRoute({ locale: locale.value, redirect: to }));
    }

    // Route-level role ACL (defense-in-depth): when `auth` is a predicate, the authenticated user
    // must also satisfy it. Deny unauthorized users exactly like unauthenticated ones.
    if (!isRouteAuthorized({ auth: to.meta.auth, user: authStore.user })) {
        return navigateTo(getLoginRoute({ locale: locale.value, redirect: to }));
    }
});
